// @flow weak
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../fetchTools';

export const logoutApi = () => {
  const url = `${getLocationOrigin()}/auth/logout`;
  const options = {...defaultOptions};
  options['method'] = 'post';

  return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => data)
    .catch(error => error);
};



// WEBPACK FOOTER //
// ./src/app/services/API/logout.js